PJQ.Loader = class {
    constructor($el, options = {}) {
        this.$el = $el;
        this.options = _.defaults(options, {
            loadingText: 'Loading...',
            type: this.$el.is(':button') ? 'button' : null,
        });
        this.init();
    }

    init() {
        switch (this.getType().toLowerCase()) {
            case 'button':
                this.$processing = $('<span>', {
                    style: 'position:absolute;color:#fff;',
                    text: this.options.loadingText
                });
                this.$el.addClass('loader loader-button').prop('disabled', true);

                if(_.size(this.options.loadingText) === 0){
                    this.$el.addClass('loader-center')
                } else{
                    this.$el.removeClass('loader-center')
                }

                this.$el.prepend(this.$processing);
                break;
            case 'iconbutton':
                this.$el.find('i').addClass('hidden');
                this.$el.addClass('loader loader-button').prop('disabled', true);

                if(_.size(this.options.loadingText) === 0){
                    this.$el.addClass('loader-center')
                } else{
                    this.$el.removeClass('loader-center')
                }

                this.$processing = $('<span>', {
                    style: 'position:absolute;color:#fff;',
                    text: this.options.loadingText
                });
                this.$el.prepend(this.$processing);
                break;
            case 'block':
                this.$el.addClass('loader');
                break;
            case 'small':
                this.$el.addClass('loader loader-overlay loader-small');
                break;
            default:
                this.$el.addClass('loader loader-overlay');
                break;
        }
    }

    getType() {
        return this.options.type ? this.options.type : '';
    }

    remove() {
        if (this.getType().toLowerCase() === 'button') {
            this.$processing.remove();
            this.$el.css('color', '').removeClass('loader loader-overlay').prop('disabled', false);
        } else if (this.getType().toLowerCase() === 'iconbutton') {
            this.$processing.remove();
            this.$el.removeClass('loader loader-overlay').prop('disabled', false);
            this.$el.find('i').removeClass('hidden');
        } else {
            this.$el.removeClass('loader').removeClass('loader-overlay');
        }
    }
};